import React from "react";
import { appMethod as app } from '@utils/app';
import OfficialPage from '../../official-page/OfficialPage';
import ReactDom from 'react-dom';
import { Toast, Icon } from 'antd-mobile';
import "./AudioTest.less";
import TextAnimation from "../component/TextAnimation/TextAnimation";
import { getCurrentPageQueryParams } from '@utils/tools';
import Dialog from "../dialog/Dialog";
import CryptoJS from "crypto-js";
import RecorderManager from '@utils/index.umd.js';
import LoginPage from "src/official-page/login-page/LoginPage";
import html2canvas from "html2canvas"
const GPTModal = {
  '0': 'GPT-3.5',
  '1': 'GPT-4'
}
const APPID = "2dcb30a7";
const API_SECRET = "Mzg2ZmYzNDIyZGQ1M2MzMDU4OWY5Yzc1";
const API_KEY = "9449a5280ed944fa8f53b23d5c1e90fd";
export default class AudioTest extends OfficialPage {
  countdownInterval = null
  recorder = null
  iatWS = null
  state = {
    canUseIntegral: 0,
    userVipCardInfo: null,
    historyNum: 0,
    roleList: [
      {
        role_id: 0,
        role_name: '会话',
        url: 'https://cdn.jisuapp.cn/static/webapp/images/chatgpt/session_role.png'
      }
    ],
    roleListAll: [],
    selectedRoleId: '',
    switchSelectedRoleId: '',
    sessionId: '', //会话id
    dialogueList : [],
    is_more: 0,
    current_page: 1,
    content: '', //提问内容
    is_audio: 0, //提问方式   0打字提问 1语音提问
    shareKey: '',
    sharePoliteData: {},
    isWeiXinBrowser: false,
    isSub: false,
    isShowAllRole: false,
    searchValue: '',
    modalType: 0, // 模型
    modalName: 'GPT-3.5', // 模型名称
    modalId: '',
    modalList: [],
    isShowModalConfig: false,

    // 录音相关数据
    isAudio: true, // 是否切换为录音
    isRecording: false, // 正在录音
    // iatWS:null, //websocket
    resultText: '', // 文字结果
    resultTextTemp: '', // 文字修正结果
    // countdownInterval:null, // 时间计数器
    seconds: 60, // 倒计时
    recordInterrupt:false,
    // recorder:null,

    maskShow: false,
    isShare: false, // 正在分享
    shareDialogList:[], // 选择分享的内容
    lastDialogId:0,
    shareImgUrl:'',
  }
  constructor(props) {
    super(props);
    document.title = '即速对话';
    this.myRef = React.createRef();
    this.textareaRef = React.createRef()
    if(app.isWeixin()){
      this.state.isWeiXinBrowser = true;
    }
  }
  componentDidMount(options = getCurrentPageQueryParams()) {
    // this.textareaRef.current && this.textareaRef.current.focus()
    // console.log(this.textareaRef,'33333')
    app.globalData.homepageRouter = 'jisugpt'; //将首页路径设置为gpt入口页
    // 为进入历史对话时
    if(options.sid && options.rid){
      this.setData({
        sessionId: options.sid,
        selectedRoleId: options.rid,
        switchSelectedRoleId: options.rid,
      })
      app.setStorage({
        key: 'nowSessionData',
        data: {
          sessionId: options.sid,
          roleId: options.rid
        }
      })
    }
    if (!app.isLogin()) {
      app.goLogin();
      return;
    }
    if(!app.getUserInfo().phone){
      Toast.info('请补充用户信息',1,()=>{
        app.turnToPage('add-phone')
      });
      return;
    }
    this.getSessionList();
    this.getIntegralDetailData();
    this.getVipInfo();
    this.getHistoryList();
    this.GetSupportTypeSet();
    this.createRecorder();
    // app.getAppCurrentPage().shareData.path = 'https://test2.zhichiwangluo.com/zc_webapp/jisugpt?app_id=' + app.getAppId()
    // this.getShareKey();
    // this.getShareData();
  }
  // 获取会员信息
  getVipInfo = () => {
    let that = this;
    app.sendRequest({
      url: '/index.php?r=appVipCard/getUserAccountSurvey',
      hideLoading: true,
      success: (res) => {
       if(res.status == 0){
        that.setState({
          userVipCardInfo: res.data.user_paid_vip_card
        })
       }
      }
    })
  }
  // 获取积分信息
  getIntegralDetailData = () => {
    let that = this
    app.sendRequest({
      url: '/index.php?r=AppShop/GetIntegralInfo',
      success: function (res) {
        that.setState({
          canUseIntegral: res.data.can_use_integral
        })
      }
    })
  }
  // 获取历史对话
  getHistoryList = () => {
    let that = this;
    app.sendRequest({
      url: '/index.php?r=ChatAI/SessionList',
      data: {
        app_id: app.getAppId(),
        page: -1,
        page_size: 1
      },
      method: 'POST',
      success: function (res) {
        that.setData({
          historyNum: res.data.length,
        })
      }
    })
  }
  // 获取会话角色
  getSessionList = () => {
    app.showLoading({
      title: '加载中..',
    })
    let that = this
    // 初始化 
    let currentSessionId = '';
    let currentRoleId = '';
    app.sendRequest({
      url: '/index.php?r=ChatAI/GetRole',
      data: {
        app_id: app.getAppId(),
        page: 1,
        page_size: 5
      },
      method: 'POST',
      success: function (res) {
        if (res.data.length != 0) {
          app.hideLoading();
          let user_roles = res.data.user_roles || [];
          let roleList = [...that.data.roleList,...user_roles,...res.data.system_role];
          roleList.forEach((item) => {
            if(item.id){
              item.role_id = item.id
            }
            if(item.title){
              item.role_name = item.title
            }
            if(item.is_default == '1'){ //设置了默认对话时
              currentRoleId = item.id
            }
          })
          that.setData({
            roleList: roleList,
            roleListAll: roleList,
          })
          // 从入口页历史对话进入
          if(that.data.sessionId && that.data.selectedRoleId){ 
            currentSessionId = that.data.sessionId;
            currentRoleId = that.data.selectedRoleId;
          }else{ // 获取历史当前打开的历史对话页
            let getSt = app.getStorageSync('nowSessionData');
            if(getSt){
              currentSessionId = getSt.sessionId;
              currentRoleId = that.data.roleList.filter(item=> item.role_id == getSt.roleId)[0].role_id;
            }
          }
          that.setData({
            sessionId: currentSessionId,
            selectedRoleId: currentRoleId,
            switchSelectedRoleId: currentRoleId,
          })
          if(currentSessionId){
            that.getSessionHistory({
              session_id: currentSessionId,
              page: that.data.current_page,
            })
          }
        }
      }
    })
  }
  // 创建会话
  creatSession = (id) => {
    let that = this;
    return new Promise((resolve, reject) => {
      let parms = {
        app_id: app.getAppId(),
      }
      if(id){
        parms['role_play_id'] = id;
      }
      app.sendRequest({
        url: '/index.php?r=ChatAI/CreateSession',
        data: parms,
        hideLoading: true,
        method: 'POST',
        complete: function (res) {
          if(res.status == 0){
            app.setStorage({
              key: 'nowSessionData',
              data: {
                sessionId: res.data,
                roleId: id?id:0
              }
            })
            that.setData({
              sessionId: res.data
            })
            resolve(res.data);
          }else{
            reject();
          }
        }
      })
    })
  }
  // 选中角色
  selectActiveItem = event => {
    let that = this
    let id = event.currentTarget.dataset.id;
    if(this.state.historyNum >= 5 && !this.state.userVipCardInfo){
      Toast.info('会话已达上限，请删除重新创建或开通会员')
      return
    }
    let session = that.data.roleList.filter(item => item.role_id == id || item.id == id)[0];
    let title  = session.role_name || session.title;
    Dialog.showModal({
      title: '是否切换对话角色为'+ title,
      confirm: () => {
        that.setData({
          selectedRoleId: session.role_id,
          dialogueList : [],
          is_more: 0,
          isShowAllRole: false,
          searchValue: '',
          roleListAll: that.data.roleList,
          switchSelectedRoleId: session.role_id
        })
        if(id == 0 || id == '0'){ //普通会话
          app.removeStorage({key: 'nowSessionData'})
          that.creatSession();
          return
        }
        that.creatSession(id);
      },
    })
  }

  bindTextInput = (event) => {
    let val = event.target.value;
    if(val){
      this.setData({
        isSub: true
      });
    }else{
      this.setData({
        isSub: false
      });
    }
    this.setData({
      'content': val,
    });
  }
  // 获取会话聊天记录
  getSessionHistory = (option,ismore = false,hideloading = false) => {
    return new Promise((resovle) => {
      let diaArr = this.state.dialogueList;
      let that = this;
      app.showLoading({
        title: '加载中..',
      })
      app.sendRequest({
        hideLoading: true,
        url: '/index.php?r=ChatAI/SessionChatList',
        hideLoading: hideloading,
        method: 'POST',
        data: {
          app_id: app.getAppId(),
          page_size: 20,
          ...option
        },
        success: function(res) {
          if(res.status == 0){
            if(res.data.length){
              resovle(res.data[0].id)
             }
            if(ismore){ // 从顶部插入
              let data = res.data.reverse();
              for(let j = data.length-1; j >= 0; j--){
                diaArr.unshift({
                  text: data[j].content,
                  direction: data[j].role == '0' ? 'ques':'reply',
                  id: data[j].id,
                  isHistory: true,
                  is_audio:data[j].is_audio
                })
              }
            }else{
              for(let i = res.data.length-1; i >= 0; i--){
                diaArr.push({
                  text: res.data[i].content,
                  direction: res.data[i].role == '0' ? 'ques':'reply',
                  id: res.data[i].id,
                  isHistory: true,
                  is_audio:res.data[i].is_audio
                })
              }
            }
            that.setData({
              dialogueList: diaArr,
              is_more:res.is_more,
              current_page: res.current_page || 1
            })
            const dialogEle  = ReactDom.findDOMNode(that.myRef.current);
            // 聊天记录聚焦最新会话 
            if(!ismore){
              dialogEle.scrollTop = dialogEle.scrollHeight;
            }
          }
        }
      })
    })
  }
  // 点击加载更多
  getMore = () => {
    this.getSessionHistory({
      session_id: this.data.sessionId,
      page: this.data.current_page+1,
    },true)
  }
  goQuestion = (option) => {
    let that = this;
    let diaArr = this.state.dialogueList;
    const oldId = diaArr.length && Number(diaArr[diaArr.length-1].id) || 0; // 暂存最后对话的id,没有就对话时赋值0
    if(this.state.canUseIntegral < 2){
      Dialog.showModal({
        title: '积分不足，请先购买会员或积分',
        confirm: function () {
          app.turnToPage('gptrecharge');
        }
      })
      return
    }
    diaArr.push({
      text: that.data.content,
      direction: 'ques',
      // id: new Date().getTime(),
      id: diaArr.at(-1).id+1,
      isLoading: true,
      is_audio:that.data.is_audio
    })
    that.setData({
      dialogueList: diaArr,
      content: '',
    })
    let dialogEle = ReactDom.findDOMNode(that.myRef.current);
    let scrollTimer = setTimeout(()=>{
      dialogEle.scrollTop = dialogEle.scrollHeight;
      clearTimeout(scrollTimer)
    })
    app.sendRequest({
      hideLoading: true,
      hideModal: true,
      url: '/index.php?r=ChatAI/AskQues',
      timeout: 40000,
      method: 'POST',
      data: {
        app_id: app.getAppId(),
        ...option
      },
      complete: function(res) {
        if(!res && oldId){ // 请求超时时，轮询获取聊天记录
          let getNewTimer = setInterval(() => {
            that.getSessionHistory({
              session_id: that.data.sessionId,
              page: 1,
            },false,true).then((newId) => {
              if(Number(newId) > oldId){
                clearInterval(getNewTimer) 
              }
            })
          },3000)
        }else{
          if(res.status == 0 && res.data.response){
            diaArr[diaArr.length - 1].isLoading = false;
            diaArr.push({
              text: res.data.response,
              direction: 'reply',
              // id: res.data.id // 这里的设置有点奇怪，接口返回的数据没有id
              id: diaArr.at(-1).id+1,
              is_audio:that.data.is_audio
            })
            that.setData({
              dialogueList: diaArr
            })
          }else{
            diaArr[diaArr.length - 1].isLoading = false;
            diaArr[diaArr.length - 1].err = true;
            Dialog.showModal({
              title: '对话异常' + res.data,
              confirm: () => {}
            })
          }
        }
        that.setData({
          content: '',
          is_audio:0
        })
        scrollTimer = setTimeout(()=>{
          dialogEle.scrollTop = dialogEle.scrollHeight; // 聊天记录聚焦最新会话
          clearTimeout(scrollTimer)
        }) 
      }
    })
    
  }
  // 提问
  askQuestions = () => {
    let {content ,sessionId, is_audio} = this.state;
    let that = this;
    if(content == ''){
      Toast.info('来说点什么吧');
      return
    }
    if(this.state.historyNum >= 5 && !this.state.userVipCardInfo){
      Toast.info('会话已达上限，请删除重新创建或开通会员')
      return
    }
    if(sessionId == '' || sessionId == 0){
      that.creatSession().then( id => {
        that.goQuestion({
          session_id: id,
          question: content,
          type: that.state.modalType,
          is_audio:is_audio
        })
      });
    }else{
      that.goQuestion({
        session_id: sessionId,
        question: content,
        type: that.state.modalType,
        is_audio:is_audio
      })
    }
    
  }
  goBack = () => {
    // app.turnBack();
    app.turnToPage('jisugpt');
  }
  toPage = () => {
    app.turnToPage('signin');
  }
  toPage2 = () => {
    app.turnToPage('myIntegral?from=userCenterEle');
  }
  // 分享的点击事件（对小程序分享按钮的另种实现）
  shareClickEvent = () => {
    let that = this;
    let sharePoliteData = this.data.sharePoliteData;
    app.showModal({
      content: sharePoliteData.title,
      showCancel: true,
      confirmColor: '#437eff',
      cancelColor: '#437eff',
      confirm: () => {
        sharePoliteData.rewards.map(item => {
          that.getRecvChance(item.type,that.data.shareKey);
        })
      },
    })
  }
  getShareKey = () => {
    let that = this;
    app.sendRequest({
      url: "/index.php?r=AppShare/GetAppShareKey",
      data: {
        app_id: app.getAppId()
      },
      success: res => {
        if (res.status == 0) {
          that.setData({
            shareKey: res.data
          })
        }
      }
    })
  }
  getRecvChance = (type, token) => {
    let that = this;
    app.sendRequest({
      hideLoading: true,
      url: '/index.php?r=ShareGiftActivity/GetRecvChance',
      method: 'POST',
      data: {
        share_type: type,
        share_token: token
      },
      success: res => {
        if (!res.data.get_chance) {
          app.shareClickEvent();
        }
      }
    })
  }
  getShareData = () => {
    let that = this;
    app.sendRequest({
      url: '/index.php?r=ShareGiftActivity/GetEffectActivity',
      data: {
        app_id: app.getAppId()
      },
      success: (res) => {
        if (res.status == 0) {
          that.setData({
            sharePoliteData: res.data
          })
        }
      }
    })
  }
  // 重新发送
  againSend = data => {
    let list = JSON.parse(JSON.stringify(this.data.dialogueList));
    list.pop();
    this.setData({
      content: data,
      dialogueList: list
    })
    this.askQuestions();

  }
  // 
  toBoxBottom = () => {
    let dialogEle  = ReactDom.findDOMNode(this.myRef.current);
    let scrollTimer = setTimeout(()=>{
      dialogEle.scrollTop = dialogEle.scrollHeight; // 聊天记录聚焦最新会话
      clearTimeout(scrollTimer)
    }) 
  }
  showAllRolePage = () => {
    this.setData({
      isShowAllRole: true
    })
  }
  hiddenAllRolePage = () => {
    this.setData({
      isShowAllRole: false
    })
  }
  bindSearInput = (event) => {
    let val = event.target.value;
    let reg = new RegExp(val);
    let Arr = this.data.roleList.filter(item => {
      if(val == item.role_name || val == item.title || reg.test(item.role_name) || reg.test(item.title)){
        return item
      }
    })
    this.setData({
      searchValue: val,
      roleListAll: Arr
    })
  }
  selectSwitchItem = (event) => {
    let that = this
    let id = event.currentTarget.dataset.id;
    that.setData({
      switchSelectedRoleId: id
    })
  }
  confirmSelect = () => {
    this.selectActiveItem({currentTarget:{dataset:{id: this.data.switchSelectedRoleId}}})
  }

  // 获取可用的配置模型
  GetSupportTypeSet = () => {
    let that = this;
    app.sendRequest({
      hideLoading: true,
      url: '/index.php?r=ChatAI/GetSupportTypeSet',
      method: 'POST',
      data: {
        app_id: app.getAppId(),
      },
      success: function(res) {
        if(res.data.length){
          that.setData({
            modalList: res.data,
            modalName: GPTModal[res.data[res.data.length-1]],
            modalId: res.data[res.data.length-1],
            modalType: res.data[res.data.length-1]
          })
        }
      }
    })
  }
  selectModal = (event) => {
    let type = event.currentTarget.dataset.type;
    this.setData({
      modalType: type,
      modalName: GPTModal[type],
      modalId: type,
      isShowModalConfig: false
    })
  }
  showSelectModalBox = () => {
    this.setData({
      isShowModalConfig: !this.data.isShowModalConfig
    })
  }

  // 语音转文字功能函数
  startSpeech = () => {
    if (!this.data.isRecording) {
			this.connectWebSocket();
		} else {
			this.recorder.stop();
		}
  }
  getWebSocketUrl = () => {
		// 请求地址根据语种不同变化
		var url = "wss://iat-api.xfyun.cn/v2/iat";
		var host = "iat-api.xfyun.cn";
		var apiKey = API_KEY;
		var apiSecret = API_SECRET;
		var date = new Date().toGMTString();
		var algorithm = "hmac-sha256";
		var headers = "host date request-line";
		var signatureOrigin = `host: ${host}\ndate: ${date}\nGET /v2/iat HTTP/1.1`;
		var signatureSha = CryptoJS.HmacSHA256(signatureOrigin, apiSecret);
		var signature = CryptoJS.enc.Base64.stringify(signatureSha);
		var authorizationOrigin =
			`api_key="${apiKey}", algorithm="${algorithm}", headers="${headers}", signature="${signature}"`;
		var authorization = btoa(authorizationOrigin);
		url = `${url}?authorization=${authorization}&date=${date}&host=${host}`;
		return url;
	}
  toBase64 = (buffer) => {
		var binary = "";
		var bytes = new Uint8Array(buffer);
		var len = bytes.byteLength;
		for (var i = 0; i < len; i++) {
			binary += String.fromCharCode(bytes[i]);
		}
		return btoa(binary);
	}
  createRecorder = async () => {
    let localWorkerUrl = ''
      // 得到字符串化的 JS 代码
      const codeString = await fetch('https://cdn.jisuapp.cn/static/webapp/js/processor/processor.worker.js').then(res => res.text());
  
      // 在这里我没有使用 new Worker(`data:application/javascript, ${codeString}`) 这种方式
      // 而是使用了 URL.createObjectURL 以及 new Blob, 会将 JavaScript 字符串转换为如下格式
      // blob:http://same-domain/cd2930c0-f4ca-4a9f-b6b1-8242e520dd62
      // 因此不再会有跨域问题
      localWorkerUrl = window.URL.createObjectURL(new Blob([codeString], {
          type: 'application/javascript'
      }));
    this.recorder = new RecorderManager( localWorkerUrl );
    // console.warn("process.env.BUILD_ENV: ", process.env.BUILD_ENV)
    this.recorder.onStart = () => {
      console.log('录音开始');
      this.setData({ isRecording: true })
    }
    this.recorder.onFrameRecorded = ({ isLastFrame, frameBuffer }) => {
      // console.log(frameBuffer,this.toBase64(frameBuffer));
      if (this.iatWS.readyState === this.iatWS.OPEN) {
        this.iatWS.send(
          JSON.stringify({
            data: {
              status: isLastFrame ? 2 : 1,
              format: "audio/L16;rate=16000",
              encoding: "raw",
              audio: this.toBase64(frameBuffer),
            },
          })
        );
        if (isLastFrame) {
          this.setData({ isRecording: false })
        }
      }
    };
    this.recorder.onStop = () => {
      console.log('录音结束');
      this.setData({resultText:'',isRecording:false})
      clearInterval(this.countdownInterval);
    };
  }
  connectWebSocket = () => {
		const websocketUrl = this.getWebSocketUrl();
		if ("WebSocket" in window) {
			this.iatWS = new WebSocket(websocketUrl);
		} else if ("MozWebSocket" in window) {
			this.iatWS = new MozWebSocket(websocketUrl);
		} else {
			alert("浏览器不支持WebSocket");
			return;
		}
		this.iatWS.onopen = (e) => {
			this.countdown()
			// 开始录音
			this.recorder.start({
				sampleRate: 16000,
				frameSize: 1280,
			});
			var params = {
				common: {
					app_id: APPID,
				},
				business: {
					language: "zh_cn",
					domain: "iat",
					accent: "mandarin",
					vad_eos: 5000,
					dwa: "wpgs",
				},
				data: {
					status: 0,
					format: "audio/L16;rate=16000",
					encoding: "raw",
				},
			};
			this.iatWS.send(JSON.stringify(params));
		};
		this.iatWS.onmessage = (e) => {
			this.renderResult(e.data)
			console.log('iatWS.onmessage: ', e.data);
		};
		this.iatWS.onerror = (e) => {
			console.error(e);
			this.recorder.stop();
		};
		this.iatWS.onclose = (e) => {
      console.log(333);
			this.recorder.stop();
      if(!this.data.recordInterrupt && this.data.resultText){
        this.setData({content:this.data.resultText,is_audio:1})
        console.log('发出去',this.data.resultText);
        this.askQuestions()

      }
			this.setData({recordInterrupt:false})
		};
	}
  countdown = () => {
    this.setData({seconds : 60})
		this.countdownInterval = setInterval(() => {
			// seconds.value = seconds.value - 1;
      this.setData({seconds : this.data.seconds - 1})
			if (this.data.seconds <= 0) {
				clearInterval(this.countdownInterval);
				this.recorder.stop();
			}
		}, 1000);
	}
  renderResult = (resultData) => {
		// 识别结束
		let jsonData = JSON.parse(resultData);
		if (jsonData.data && jsonData.data.result) {
			let data = jsonData.data.result;
			let str = "";
			let ws = data.ws;
			for (let i = 0; i < ws.length; i++) {
				str = str + ws[i].cw[0].w;
			}
			// 开启wpgs会有此字段(前提：在控制台开通动态修正功能)
			// 取值为 "apd"时表示该片结果是追加到前面的最终结果；取值为"rpl" 时表示替换前面的部分结果，替换范围为rg字段
			if (data.pgs) {
				if (data.pgs === "apd") {
					// 将resultTextTemp同步给resultText
					this.setData({resultText: this.data.resultTextTemp})
				}
				// 将结果存储在resultTextTemp中
        this.setData({resultTextTemp: this.data.resultText + str})
			} else {
        this.setData({resultText: this.data.resultText + str})
			}
		}
		if (jsonData.code === 0 && jsonData.data.status === 2) {
			this.iatWS.close();
		}
		if (jsonData.code !== 0) {
			this.iatWS.close();
			console.error(jsonData);
		}
	}
  cancelRecord = async (event,type=false) => {
    console.log(type,'cancelRecord',this);
    this.setData({recordInterrupt:true})
    await this.recorder.stop()
    type && this.textareaRef.current && this.textareaRef.current.focus()
    type && console.log(this.textareaRef,'33333')
    // console.log(type,'222222');
	}

  closeMask = (event) => {
    event.persist()
    event.target.id  == 'mask' && this.setData({maskShow : false})
	}
  openShare = () => {
    this.setData({maskShow : true})
	}
  startShare = (index) => {
    this.setData({isShare : true})
    this.selectThisDialog(index)
	}
  cancelShare = () => {
    this.setData({isShare : false,shareDialogList:[],maskShow:false,shareImgUrl:''})
	}
  selectThisDialog = (index) => {
    let item = this.data.dialogueList[index]
    let shareDialogList = this.data.shareDialogList
    let inx = shareDialogList.findIndex((ele)=>{return item.id == ele.id})

    if(item.direction == 'reply'){
      let item2 = this.data.dialogueList[index-1]
      if(inx == -1){
        shareDialogList.push(item2,item)
      }else{
        shareDialogList.splice(inx-1,2)
      }
    }else{
      let item2 = this.data.dialogueList[index+1]
      if(inx == -1){
        shareDialogList.push(item,item2)
      }else{
        shareDialogList.splice(inx,2)
      }
    }
    shareDialogList.sort((a, b) => a.id - b.id);
    this.setData({shareDialogList})
	}
  isInShareDialogList = (item) => {
    // console.log(item,this.data.shareDialogList.some(ele=>item.id == ele.id),'isInShareDialogList');
    return this.data.shareDialogList.some(ele=>item.id == ele.id)
	}
  createShareImg = () => {
    this.setData({maskShow : true})
    this.exportPictureDownPNG()
	}
  saveShareImg = () => {
    const link = document.createElement('a');
    link.href = this.state.shareImgUrl;
    link.download = 'shareImg.png';
  
    // 模拟点击下载链接，触发下载
    link.click();
    // document.body.removeChild(link);
    this.cancelShare()
	}
  shareWechat = () => {
    Dialog.showModal({
      title: '功能正在开发，可保存图片分享',
      confirm: function () {
        console.log('好的');
      }
    })
	}
shareCircle = () => {
  Dialog.showModal({
    title: '功能正在开发，可保存图片分享',
    confirm: function () {
      console.log('好的');
    }
  })
	}
  stopAudio = () => {
    window.speechSynthesis.pause()
	}
  // 生成图片

exportPictureDownPNG = () => {
  let that = this
  setTimeout(() => {
    if(navigator.appName == "Microsoft Internet Explorer" && navigator.appVersion .split(";")[1].replace(/[ ]/g,"") == "MSIE8.0" || navigator.appVersion .split(";")[1].replace(/[ ]/g,"") == "MSIE9.0") {
      //IE亲测
  alert("请升级您的IE浏览器版本，暂不支持IE9及以下版本导出图片。")
}
// html2canvas(document.getElementById('shareImg'), {
//   onrendered: function(canvas) {
//     var imgData = canvas.toDataURL('image/octet-stream');
//     if (canvas.msToBlob) {     // IE 9+浏览器
//       var blob = canvas.msToBlob();
//       window.navigator.msSaveBlob(blob, pngName);
//       console.log('22222222');

//     }else {
//       console.log('1111111111');
//       // saveFile(imgData,pngName);
//     }
//     console.log('333333333',imgData);

//   }
// });
html2canvas(document.getElementById('shareImg'),{
  useCORS:true
}).then(function(canvas) {
  let dataUrl = canvas.toDataURL();
  const blob = that.dataURLtoBlob(dataUrl);
  // 创建临时URL
  const url = URL.createObjectURL(blob);
  that.setData({shareImgUrl:url})
});
  }, 1000);

}
// convertUrlToBase64 = (url) => {
//   return new Promise((resolve) => {
//       let img = new Image();
//       img.crossOrigin = 'Anonymous';
//       img.src = url;
//       img.onload = function () {
//           let canvas = document.createElement('canvas');
//           canvas.width = img.width;
//           canvas.height = img.height;
//           let ctx = canvas.getContext('2d');
//           ctx.drawImage(img, 0, 0, img.width, img.height);
//           let ext = img.src.substring(img.src.lastIndexOf('.') + 1).toLowerCase();
//           let dataURL = canvas.toDataURL('image/' + ext);
//           let base64 = {
//               dataURL: dataURL,
//               type: 'image/' + ext,
//               ext: ext
//           };
//           resolve(base64)
//       }
//   })
// }
dataURLtoBlob = dataURL => {
  const arr = dataURL.split(',');
  const mime = arr[0].match(/:(.*?);/)[1];
  const bstr = atob(arr[1]);
  let n = bstr.length;
  const u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new Blob([u8arr], { type: mime });
}
closeAndSend=()=>{
  this.iatWS.close()
}

  render() {
    let { content, roleList, selectedRoleId, is_more, isWeiXinBrowser, isSub, roleListAll, switchSelectedRoleId, isShowAllRole, searchValue,
      modalName, modalId, modalList, isShowModalConfig, isAudio, isRecording, seconds,resultText,maskShow,isShare} = this.state;
    return (
      <div className="gpt_page">
        {!isWeiXinBrowser &&
        <div className="head">
         { !isShare && 
         <img src="https://cdn.jisuapp.cn/static/webapp/images/chatgpt/icon_l_big.png" alt="back" onClick={this.goBack}/>
         }
         { isShare && 
         <div className="head_btn" onClick={this.cancelShare}>取消</div>
         }
         <div>{isShare ? '选择分享内容' : '即速对话'}</div>
        </div>
        }
        <div className={'main ' + (isWeiXinBrowser?'':'pd_t35')} ref={this.myRef}>
          <div className="tab_box">
            <div>角色切换</div>
            <div className="tab_list">
            {roleList.map((item, index) => {
              if(index < 5){
                return (<div className={'tab ' + (selectedRoleId == item.role_id || selectedRoleId == item.id ? 'active' : '')}
                data-id={item.role_id || item.id} key={index} onClick={this.selectActiveItem}>
                  {item.url && <img className='roleimg' src={item.url} />}
                  <span>{item.role_name || item.title}</span></div>)
              }
            })}
              {roleList.length > 6 && <div className="tab" onClick={this.showAllRolePage}>更多{'  >'}</div>}
            </div>
          </div>
        {is_more == 1 &&
          <div className="request-all" onClick={this.getMore}>点击加载更多</div>
        }
        {this.state.dialogueList.map((item,index) =>
          <div key={item.id + '-' + index} className="text_animation_box">
            {item.direction != "reply" && isShare && <div className="select_share_btn img" onClick={this.selectThisDialog.bind(this,index)} style={{backgroundImage:`url(https://cdn.jisuapp.cn/static/webapp/images/chatgpt/audio/${this.isInShareDialogList.bind(this,item)()?'audio-share-selected':'audio-share-select'}.png)`}}></div>}
            {item.direction != "reply" && (!isShare) && <div className="select_share_btn"></div>}
            {/* {item.direction != "reply" && isShare && <img className="select_share_btn" onClick={this.selectThisDialog.bind(this,index)} src="https://cdn.jisuapp.cn/static/webapp/images/chatgpt/copy.png" alt="" />} */}
            <TextAnimation data={item} againSend={this.againSend} toBoxBottom={this.toBoxBottom} startShare={this.startShare.bind(this,index)} highLight={isShare && this.isInShareDialogList.bind(this,item)()}/>
          </div>
          
        )}
        </div>
        {!isShare &&
          <div className="footer">
            <div className="row jc_sb">
              {/* <div className="nav" onClick={this.shareClickEvent}>分享送积分</div> */}
              <div className="nav" onClick={this.goBack}>{'< '}历史对话</div>
              <div className="nav" onClick={this.toPage}>签到送积分</div>
              <div className="nav" onClick={this.toPage2}>我的积分</div>
              <div className="nav" onClick={modalList.length>1?this.showSelectModalBox:null}>模型选择</div>
            </div>
            {isShowModalConfig && <div className='tool_config'>
              {modalList.map((item) => 
                <div className={modalId == item?'config_item config_item_select':'config_item'} key={item} onClick={this.selectModal} data-type={item}> {GPTModal[item]}</div>
              )}
            </div>}
            <div className="row say_box jc_sa">
              <textarea  ref={this.textareaRef} className="ipt_box" placeholder="来说点什么吧（消耗2积分）" onInput={this.bindTextInput} onChange={this.bindTextInput} value={content}/>
              {(content.length !== '') && isSub && <div className={isSub?'sub_btn':'sub_btn un_sub'} onClick={isSub?this.askQuestions:null}>发送</div>}
              {/* {!isSub && <div className="microphone_icon" onClick={this.stopAudio}></div>} */}
              {(content.length == '') && !isSub && <div className="microphone_icon" onClick={this.startSpeech}></div>}
            </div>
          </div>
        }
        {
          isRecording && 
          <div className="record_box">
            <div className="record_text_box">
              {/* {resultText.length <= 0 && <p className="record_text">我没听清，请再说一遍!</p>} */}
              <p className="timeText">00:{seconds<10 ? '0'+seconds : seconds}</p>
              { resultText.length > 0 && <p className="record_text">{resultText}</p> }
              { seconds <= 5 && <p className="timeText"><span style={{color:'#F24545'}}>{seconds}”</span>后停止录音</p> }
            </div>
            <div className="row jc_sa record_btn_box">
              <div className="record_btn img" style={{backgroundImage:'url(https://cdn.jisuapp.cn/static/webapp/images/chatgpt/audio/audio-close.png)'}} onClick={(e) => this.cancelRecord(e)}></div>
              <div className="record_animation" onClick={this.closeAndSend}>
                <div className="spectrum_bar spectrum_bar1"></div>
                <div className="spectrum_bar spectrum_bar2"></div>
                <div className="spectrum_bar spectrum_bar3"></div>
                <div className="spectrum_bar spectrum_bar4"></div>
                <div className="spectrum_bar spectrum_bar5"></div>
                <div className="spectrum_bar spectrum_bar6"></div>
              </div>
              <div className="record_btn img"  onClick={(e) => this.cancelRecord(e,true)} style={{backgroundImage:'url(https://cdn.jisuapp.cn/static/webapp/images/chatgpt/audio/audio-type.png)'}}></div>
            </div>
          </div>
        }
        {
          isShare &&
          <div className="row jc_sa share_btm_box"> 
              <div className="share_btm_item" onClick={this.shareWechat}><img className="share_btm_img" src="https://cdn.jisuapp.cn/static/webapp/images/chatgpt/audio/audio-share-wechat.png" alt="" /><p className="share_btm_text">微信好友</p></div>
              <div className="share_btm_item" onClick={this.shareCircle}><img className="share_btm_img" src="https://cdn.jisuapp.cn/static/webapp/images/chatgpt/audio/audio-share-circle.png" alt="" /><p className="share_btm_text">朋友圈</p></div>
              <div className="share_btm_item" onClick={this.createShareImg}><img className="share_btm_img" src="https://cdn.jisuapp.cn/static/webapp/images/chatgpt/audio/audio-share-pic.png" alt="" /><p className="share_btm_text">生成图片</p></div>
              {this.state.shareDialogList.length == 0 && <div className="prevent_share"></div>}
            </div>
        }
        
        
        {
          isShowAllRole == true &&
          <div className='drawer_box'> 
            <div className='mask' onClick={this.hiddenAllRolePage}></div>
            <div className='drawer'>
              <div className='drawer_head'>
                <div className="d_title_line">
                  <div className='d_title'>角色切换</div>
                  <Icon type="cross-circle-o" size='xs' onClick={this.hiddenAllRolePage}/>
                </div>
                <div className='ipt_box'>
                  <label className='ico-moon icon-search'></label>
                  <input type="text" placeholder="请输入角色名称" value={searchValue} onInput={this.bindSearInput} onChange={this.bindSearInput} onClick={this.debubbling}/>
                </div>
              </div>
              <div className='drawer_main'>
              {roleListAll.map((item, index) => {
                return (<div className={'role_item ' + (switchSelectedRoleId == item.role_id || switchSelectedRoleId == item.id ? 'active' : '')}
                data-id={item.role_id || item.id} key={index} onClick={this.selectSwitchItem}>
                  {item.url && <img src={item.url} />}
                  <div>{item.role_name || item.title}</div>
                  <input type="radio" checked={switchSelectedRoleId == item.role_id || switchSelectedRoleId == item.id} onChange={function(){return false;}}/>
                </div>)
              })}
              </div>
              <div className="drawer_footer">
                <div className="drawer_btn" onClick={this.confirmSelect}>确定</div>
              </div>
            </div>
          </div>
        }
        {
          maskShow && 
          <div id="mask" className="mask" onClick={this.closeMask}>
            <div  id="shareImg" className="share_content_box">
              <div className="share_content_head"><img className="share_logo" src="https://cdn.jisuapp.cn/static/webapp/images/chatgpt/audio/audio-share-logo.png" alt="" /></div>
              <div className="share_content">
              {this.state.shareDialogList.map((item,index) =>
          <div key={item.id + '-' + index} className="text_animation_box"> 
            {/* {item.direction != "reply" && isShare && <img className="select_share_btn" onClick={this.selectThisDialog.bind(this,index)} src="https://cdn.jisuapp.cn/static/webapp/images/chatgpt/copy.png" alt="" />} */}
            <TextAnimation data={item} againSend={this.againSend} toBoxBottom={this.toBoxBottom} startShare={this.startShare} highLight={isShare && this.isInShareDialogList.bind(this,item)()}/>
          </div>
          
        )}
              </div>
              <div className="share_content_foot">
                <img className="share_tips" src="https://cdn.jisuapp.cn/static/webapp/images/chatgpt/audio/audio-share-tips.png" alt="" />
                <div className="code_box"></div>
              </div>
            </div>
            <div className="row jc_sa share_btm_box">
              <div className="share_btm_item" onClick={this.shareWechat}><img className="share_btm_img" src="https://cdn.jisuapp.cn/static/webapp/images/chatgpt/audio/audio-share-wechat.png" alt="" /><p className="share_btm_text">微信好友</p></div>
              <div className="share_btm_item" onClick={this.shareCircle}><img className="share_btm_img" src="https://cdn.jisuapp.cn/static/webapp/images/chatgpt/audio/audio-share-circle.png" alt="" /><p className="share_btm_text">朋友圈</p></div>
              <div className="share_btm_item" onClick={this.saveShareImg}><img className="share_btm_img" src="https://cdn.jisuapp.cn/static/webapp/images/chatgpt/audio/audio-share-download.png" alt="" /><p className="share_btm_text">保存图片</p></div>
            </div>
          </div>
        }
      </div>
      
    );
  }
}



// WEBPACK FOOTER //
// ./src/chatgpt-page/audio-test/AudioTest.jsx